import React, {useState} from "react";
import {Button} from "react-bootstrap";
import {AiFillEye, AiFillEyeInvisible} from "react-icons/ai";
import {TbCopy} from "react-icons/tb";

export default function PasswordField({value, row, copyTextToClipboard}) {
    const replaceChars = (text, char) => {
        if (!text) {
            return '';
        }
        let newStr = '';
        for (let i = 0; i < 8; i++) {
            newStr += char;
        }
        return newStr;
    }
    const forceUpdate = useForceUpdate();
    const hiddenPassword = replaceChars(value, '*');
    const [showPassword, setShowPassword] = useState(false);

    return value === '' ? null : (
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
            <div className={'d-inline-block'}/>
            <div className={'d-inline-block  mr-4'}/>
            <div className={'d-inline-block mt-2'}>
                {showPassword ? value : hiddenPassword}
            </div>
            <div className={'d-inline-block'}>
                <Button variant={'link'} style={{color: 'grey'}} onClick={() => {
                    setShowPassword(!showPassword);
                    forceUpdate();
                }}
                >
                    {showPassword ? <AiFillEyeInvisible/> : <AiFillEye/>}
                </Button>
                <Button className='p-0 m-0' variant={'link'} style={{color: 'black'}}>
                    <TbCopy size={25} onClick={() => copyTextToClipboard(value)}/>
                </Button>
            </div>
        </div>
    )
}

function useForceUpdate() {
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update the state to force render
}
